import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import MemberForm from './components/MemberForm';
import MemberDetail from './components/MemberDetail';
import Settings from './components/Settings';
import IntelligenceCentre from './components/IntelligenceCentre';
import Photos from './components/Photos';
import './i18n';
import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  
  if (loading) {
    return <div style={{ textAlign: 'center', padding: '100px' }}>Loading...</div>;
  }
  
  return user ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  
  if (loading) {
    return <div style={{ textAlign: 'center', padding: '100px' }}>Loading...</div>;
  }
  
  return !user ? children : <Navigate to="/" />;
}

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/intelligence" element={<PrivateRoute><IntelligenceCentre /></PrivateRoute>} />
          <Route path="/photos" element={<PrivateRoute><Photos /></PrivateRoute>} />
          <Route path="/member/new" element={<PrivateRoute><MemberForm /></PrivateRoute>} />
          <Route path="/member/:id" element={<PrivateRoute><MemberDetail /></PrivateRoute>} />
        </Routes>
      </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
